const cardNumbers : {[key:string] : number} = {
   ZERO:0,
   ONE:1,
   TWO:2,
   THREE:3,
   FOUR:4,
   FIVE:5,
   SIX:6,
   SEVEN:7,
   EIGHT:8,
   NINE:9,
   //special cards
   DRAW_TWO:10,
   REVERSE:11,
   SKIP:12,
   NONE:13
}
export default cardNumbers